import React, { useEffect, useRef, useState } from 'react'
import { Formik } from 'formik'
import { Modal, Tooltip } from 'antd'

import { Input } from 'src/components/Formik'
import { RequestUserData } from 'src/types'

import * as CSS from './styles'
import getValidationSchema from './validation-schema'

type Action = 'approve' | 'cancel' | 'disapprove' | null

export type ModalActionType = {
  action: Action
  title: string
}

const initialValues = {
  justification: ''
}

interface Props {
  handleSubmit: (justification: string, users: RequestUserData[]) => void
  isLoading: boolean
  modalAction: ModalActionType
  request_user_data: RequestUserData[]
  toggleAction: (action: Action) => void
  userReduce(acc: RequestUserData[], cur: RequestUserData): RequestUserData[]
}

export default function ModalAction({
  handleSubmit,
  isLoading,
  modalAction,
  request_user_data,
  toggleAction,
  userReduce
}: Props) {
  const refFormik = useRef(null)
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading])

  useEffect(() => {
    if (!modalAction) {
      setVisible(false)
      return
    }
    refFormik.current?.resetForm()
    setVisible(true)
  }, [modalAction])

  let users = request_user_data

  if (modalAction?.action !== 'cancel') {
    users = request_user_data.reduce(userReduce, [])
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={values => {
        if (!modalAction) {
          return
        }
        handleSubmit(values.justification, users)
      }}
      ref={refFormik}
      render={formikProps => (
        <Modal
          visible={visible}
          onOk={() => {
            formikProps.submitForm()
          }}
          okButtonProps={{ loading }}
          cancelButtonProps={{ loading }}
          onCancel={() => {
            setVisible(false)
            setTimeout(() => {
              toggleAction(null)
            }, 200)
          }}
          width={400}
        >
          <>
            <span>{modalAction?.title}</span>
            <CSS.ContainerAvatar>
              {users.map(userDataItem => (
                <Tooltip
                  key={userDataItem.traveler.user_id}
                  title={userDataItem.traveler.name}
                >
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a>
                    <CSS.Avatar
                      gender={userDataItem.traveler.gender}
                      name={userDataItem.traveler.name}
                    />
                  </a>
                </Tooltip>
              ))}
            </CSS.ContainerAvatar>
            {modalAction?.action !== 'approve' && (
              <CSS.ContainerInputJustification>
                <Input
                  allowClear
                  formikProps={formikProps}
                  name="justification"
                  placeholder="web.approvals.justification.placeholder"
                  size="large"
                />
              </CSS.ContainerInputJustification>
            )}
          </>
        </Modal>
      )}
      validationSchema={getValidationSchema(modalAction?.action)}
    />
  )
}
